export const getHistoryEventIds = event =>
  event?.history_event_ids || (event?.id ? [event.id] : []);

export const getUndoThroughEventIds = (historyOptions, optionIndex) => {
  const rangeOptions = historyOptions
    .slice(0, optionIndex + 1)
    .filter(option => !option.empty);
  if (
    !rangeOptions.length ||
    rangeOptions.some(
      option => !option.event?.is_undone && !option.event?.can_undo
    )
  ) {
    return [];
  }

  return rangeOptions.flatMap(option =>
    option.event?.can_undo ? getHistoryEventIds(option.event) : []
  );
};

export const getRedoThroughEventIds = (historyOptions, optionIndex) => {
  const selectedOption = historyOptions[optionIndex];
  if (!selectedOption?.event?.can_redo) return [];

  let rangeEnd = optionIndex;
  while (
    rangeEnd + 1 < historyOptions.length &&
    historyOptions[rangeEnd + 1]?.event?.is_undone
  ) {
    rangeEnd += 1;
  }

  const rangeOptions = historyOptions.slice(optionIndex, rangeEnd + 1);
  if (rangeOptions.some(option => !option.event?.can_redo)) return [];
  return rangeOptions.flatMap(option => getHistoryEventIds(option.event));
};
